import { FC, ReactNode } from 'react';

/*
 * Line icons used in the DigitaltMuseum views. They use currentColor and are 24×24.
 */

interface IconProps {
  className?: string,
  strokeWidth?: number,
  children: ReactNode
}

const Icon: FC<IconProps> = ({ className, strokeWidth = 1.8, children }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

/** Object type filter */
export const TagIcon: FC = () => <Icon><path d="M3 12V4a1 1 0 011-1h8l9 9-9 9-9-9z"/><circle cx="8" cy="8" r="1.5"/></Icon>;

/** Museum filter */
export const MuseumIcon: FC = () => <Icon><path d="M3 9.5L12 4l9 5.5M4.5 9.5h15M6 9.5v8M10 9.5v8M14 9.5v8M18 9.5v8M3.5 20.5h17M4.5 17.5h15"/></Icon>;

/** Period filter */
export const CalendarIcon: FC = () => <Icon><rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/></Icon>;

/** Subject filter */
export const LayersIcon: FC = () => <Icon><path d="M12 3l9 5-9 5-9-5 9-5z"/><path d="M3 13l9 5 9-5"/></Icon>;

/** Sort dropdown */
export const SortIcon: FC = () => <Icon><path d="M7 20V4M3.5 7.5L7 4l3.5 3.5M17 4v16M13.5 16.5L17 20l3.5-3.5"/></Icon>;

/** Placeholder for objects without images */
export const NoImageIcon: FC<{ className?: string }> = ({ className }) => (
  <Icon className={className} strokeWidth={1.2}><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="M21 17l-5-5-9 8"/></Icon>
);

/** Magnifying glass with plus */
export const ZoomIcon: FC = () => <Icon strokeWidth={2}><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M10.5 7.5v6M7.5 10.5h6"/></Icon>;

/** 3D models */
export const CubeIcon: FC = () => <Icon strokeWidth={1.6}><path d="M12 2.5l8.5 4.75v9.5L12 21.5l-8.5-4.75v-9.5L12 2.5z"/><path d="M3.5 7.25L12 12l8.5-4.75M12 12v9.5"/></Icon>;

/** Chevron pointing down */
export const ChevronDownIcon: FC<{ className?: string }> = ({ className }) => <Icon className={className} strokeWidth={2}><path d="M6 9l6 6 6-6"/></Icon>;

/** Play triangle (filled) */
export const PlayIcon: FC = () => <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4.5v15l13-7.5z"/></svg>;
